import { render, staticRenderFns } from "./tallaParaLaEdadNinos0a2A.vue?vue&type=template&id=0546f402&scoped=true&"
import script from "./tallaParaLaEdadNinos0a2A.vue?vue&type=script&lang=js&"
export * from "./tallaParaLaEdadNinos0a2A.vue?vue&type=script&lang=js&"
import style0 from "./tallaParaLaEdadNinos0a2A.vue?vue&type=style&index=0&id=0546f402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0546f402",
  null
  
)

export default component.exports